$(document).on('turbo:load', () => $(document).on("ajax:beforeSend", "#new_contact_submission", (e, xhr, settings)=> {
  if (typeof Intercom === "function") {
    xhr.setRequestHeader("X-Intercom-Visitor-Id", Intercom("getVisitorId"));
  }
}));
